// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Hp-z","imageAndVideoCount":"Ip-z","imageAndVideoContainer":"Jp-z","viewAllReviews":"Kp-z"};